import { render, staticRenderFns } from "./PlayerTable.vue?vue&type=template&id=3a57d4b6&scoped=true&"
import script from "./PlayerTable.vue?vue&type=script&lang=js&"
export * from "./PlayerTable.vue?vue&type=script&lang=js&"
import style0 from "./PlayerTable.vue?vue&type=style&index=0&id=3a57d4b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a57d4b6",
  null
  
)

export default component.exports